module.exports = __webpack_public_path__ + "static/media/maf-51.2b4b31e7.png";